// extracted by mini-css-extract-plugin
module.exports = {"triggerClassName":"ListNftButton_triggerClassName__BXKWp"};